type Props = {
    text: string
    clazz?: string
  };

function Title({text, clazz = 'text-4xl md:text-5xl'}: Props) {
    return (
        <h1 className={`font-sans font-extrabold tracking-tight ${clazz} text-slate-900 text-left`}>
            {text}
        </h1>
    );
}

export default Title;